(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.factory('Item', [ItemFactoryFn]);

    // item factory for handling in tables
    function ItemFactoryFn() {

        var Item = function (prototype, requiredFields) {

            //add fields
            if (typeof prototype !== 'undefined') {
                angular.extend(this, prototype);
            }//if

            // default values
            this.fK_Language = null;
            this.deleted = false;

            // view variables
            this.vmEditable = false;
            this.vmNew = false;
            this.language = null;
            // intern index for right selecting and deleting (because of hidden elements)
            this.vmIndex = 0;

            // extend object
            function extend(object) {
                var self = this;
                angular.extend(self, object);
            } // extend           

            // is field required ?
            function isFieldRequired(field) {
                if (typeof requiredFields === 'undefined' || requiredFields === null)
                    return false;

                for (var i = 0; i < requiredFields.length; i++) {
                    if (requiredFields[i] == field)
                        return true;
                }

                return false;
            }

            //public
            this.extend = extend;
            this.isFieldRequired = isFieldRequired;
        };

        // prepare for backend save
        Item.prototype.prepareForSave = function () {
            var self = this;

            // set language id
            if (self.language) {
                self.fK_Language = self.language.id;
            }

            delete self.vmEditable;
            delete self.vmNew;
            delete self.language;
            delete self.vmIndex;
        };



        return Item;
    }
})();